// Compatibility re-export (BKPE-27795). See `features/observability/logger/no-circular-logger`.
export * from 'features/observability/logger/no-circular-logger';
